/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

/**
 * This is here because DART requires it. It is noop in JS.
 */
export function wtfInit() {}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
